import { gql } from '@apollo/client'

import { ProjectEmailSettingsFragment } from '../fragments/project-email-settings.fragment'

export const FIND_PROJECT_EMAIL_SETTINGS = gql`
  query findProjectEmailSettings($projectId: ID!) {
    projectEmailSettings(projectId: $projectId) {
      ...ProjectEmailSettingsFragment
    }
  }
  ${ProjectEmailSettingsFragment}
`
